var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 79,
    viewBox: "0 0 72 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4561 78.468V59.0637L1.6232 48.4011V57.1405L38.4561 78.468Z",
    fill: "#F7900B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4566 64.2067L70.3806 51.9985V60.0609L38.4566 78.4679V64.2067Z",
    fill: "#FFB700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.534 72.9466L71.5 53.9387V51.0836L0.5 48.0684V50.9234L38.534 72.9466Z",
    fill: "#6D6D6D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.534 70.0916L71.5 51.0837L33.466 29.0605L0.5 48.0685L38.534 70.0916Z",
    fill: "#C7C7C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6973 45.7825L28.4961 36.6737C31.1863 35.1222 34.5006 35.1258 37.1874 36.6819L59.3044 49.4887C60.7971 50.3527 60.7947 52.5063 59.3009 53.3679L43.5022 62.4767C40.8119 64.0281 37.4977 64.0246 34.8109 62.4685L12.6938 49.6617C11.2011 48.7977 11.2035 46.6442 12.6973 45.7825ZM13.0591 49.0351L35.1761 61.8418C36.3855 62.5422 37.7646 62.9116 39.1636 62.9116C40.5579 62.9116 41.9323 62.5445 43.1393 61.8489L58.9392 52.7401C59.4133 52.4665 59.6966 51.9755 59.6966 51.4283C59.6966 50.8812 59.4145 50.3913 58.9403 50.1153L36.8233 37.3085C35.614 36.6082 34.2349 36.2388 32.8359 36.2388C31.4416 36.2388 30.0683 36.6059 28.8601 37.3015L13.0603 46.4103C12.5861 46.6839 12.3028 47.1749 12.3028 47.7209C12.3028 48.2693 12.5849 48.7603 13.0591 49.0351Z",
    fill: "#A1A1A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5342 70.0918V72.9468L0.500175 50.9237V48.0686L38.5342 70.0918Z",
    fill: "#3D3D3D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7878 18.5696L19.2122 20.6401V70.2434L15.7878 68.1716V18.5696Z",
    fill: "#F87F12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7219 19.1692L19.2131 20.64V70.2432L21.7219 68.7724V19.1692Z",
    fill: "#BA6900"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2976 17.0994L15.7888 18.5701L19.2131 20.6407L21.7219 19.1699L18.2976 17.0994Z",
    fill: "#838383"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3065 25.8961L29.562 17.1006L27.2897 1.85034L12.0353 10.6458L14.3065 25.8961Z",
    fill: "#272727"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1631 10.2076L25.4782 5.59302L14.5848 11.8748L15.2696 16.4894L26.1631 10.2076Z",
    fill: "#27A427"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3822 9.81129L24.8133 5.9765L25.4782 5.59302L26.1631 10.2076L15.2696 16.4894L15.1537 15.7085L25.3822 9.81129Z",
    fill: "#084D08"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0345 10.6455L27.2888 1.84998L25.0176 0.507812L9.76216 9.30327L12.0345 10.6455Z",
    fill: "#838383"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76192 9.30396L12.0342 10.6461L14.3054 25.8964L9.76192 23.246V9.30396Z",
    fill: "#0E0E0E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3696 15.5569L18.1732 16.2327L18.3956 17.8098L19.5933 17.1387L19.3696 15.5569Z",
    fill: "#C7C7C7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0635 14.6152L19.8658 15.291L20.0895 16.8694L21.2871 16.1971L21.0635 14.6152Z",
    fill: "#C7C7C7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7576 13.6731L21.56 14.3489L21.7824 15.926L22.9812 15.2549L22.7576 13.6731Z",
    fill: "#C7C7C7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4514 12.7324L23.255 13.407L23.4774 14.9854L24.675 14.3131L24.4514 12.7324Z",
    fill: "#C7C7C7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6687 17.675L18.4711 18.3508L18.6947 19.928L19.8923 19.2569L19.6687 17.675Z",
    fill: "#C7C7C7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3626 16.7327L20.165 17.4084L20.3886 18.9867L21.5862 18.3145L21.3626 16.7327Z",
    fill: "#C7C7C7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0567 15.792L21.859 16.4678L22.0814 18.0449L23.2803 17.3739L23.0567 15.792Z",
    fill: "#C7C7C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7505 14.8506L23.5529 15.5264L23.7765 17.1035L24.9741 16.4313L24.7505 14.8506Z",
    fill: "#C7C7C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9678 19.7937L18.7701 20.4695L18.9938 22.0466L20.1914 21.3755L19.9678 19.7937Z",
    fill: "#C7C7C7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6619 18.853L20.4643 19.5288L20.6879 21.106L21.8855 20.4337L21.6619 18.853Z",
    fill: "#C7C7C7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3557 17.9102L22.1593 18.5859L22.3817 20.1631L23.5793 19.492L23.3557 17.9102Z",
    fill: "#C7C7C7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0498 16.9692L23.8522 17.645L24.0758 19.2222L25.2734 18.5499L25.0498 16.9692Z",
    fill: "#C7C7C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.272 59.4563L22.2663 49.6764V40.3303L39.272 50.1102V59.4563Z",
    fill: "#AB7835"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2732 50.1107L22.2675 40.3308L38.7792 30.7708L55.7849 40.5518L39.2732 50.1107Z",
    fill: "#EBC26C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7849 40.5518L39.2732 50.1107V59.4568L55.7849 49.9458V40.5518Z",
    fill: "#C9974B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.903 44.4385L53.8971 45.9841L53.1818 46.3898L53.1877 44.8442L52.8306 45.0464L53.5494 43.5254L54.26 44.2351L53.903 44.4385Z",
    fill: "#965A2C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5923 50.6176L23.9465 42.7715V49.1691L37.5923 57.0152V50.6176Z",
    stroke: "#471D1D",
    strokeWidth: 0.250531,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4863 54.6141V52.3284L35.8939 51.9916C35.5954 51.8221 35.3671 51.7906 35.2067 51.8981C35.0463 52.0069 34.9667 52.2383 34.9667 52.5961C34.9667 52.9539 35.044 53.2789 35.2009 53.5747C35.3566 53.8693 35.5942 54.1078 35.9127 54.289L36.4863 54.6141ZM36.1117 53.9523L35.8752 53.8179C35.7031 53.7197 35.572 53.5864 35.4795 53.4145C35.3882 53.2438 35.3425 53.0474 35.3425 52.8206C35.3425 52.5961 35.3882 52.4488 35.4795 52.3786C35.572 52.3085 35.7125 52.3295 35.9033 52.4382L36.1117 52.5575V53.9523Z",
    fill: "#471D1D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6428 53.5647V51.279L33.4347 50.5916V51.0464L34.2694 51.521V51.991L33.5178 51.5643V51.9945L34.2694 52.4224V52.9029L33.4089 52.4119V52.8609L34.6428 53.5647Z",
    fill: "#471D1D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.074 52.672V50.3864L32.6993 50.1736V52.0033L31.9852 51.5964V52.0512L33.074 52.672Z",
    fill: "#471D1D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7117 51.8957V49.61L31.3382 49.3972V51.6829L31.7117 51.8957Z",
    fill: "#471D1D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1406 49.2846L30.7356 49.0543L30.3083 50.2667L29.8821 48.568L29.4771 48.3376L30.1502 51.0068L30.4675 51.1869L31.1406 49.2846Z",
    fill: "#471D1D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2781 50.5104V48.2248L28.0699 47.5361V47.9921L28.9035 48.4668V48.9368L28.1519 48.51V48.9403L28.9035 49.367V49.8476L28.043 49.3577V49.8066L29.2781 50.5104Z",
    fill: "#471D1D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7095 49.6165V47.3308L27.0726 46.9684C26.8116 46.8199 26.6266 46.7743 26.5154 46.8328C26.4041 46.8901 26.3491 47.0525 26.3491 47.3179C26.3491 47.685 26.4557 47.9797 26.6676 48.2077L26.2438 48.7829L26.705 49.0448L27.0761 48.5292L27.3349 48.6765V49.4037L27.7095 49.6165ZM27.3349 48.2334L27.0621 48.0779C26.9345 48.0042 26.8467 47.9259 26.7999 47.8441C26.7542 47.7611 26.7308 47.6582 26.7308 47.5354C26.7308 47.4126 26.7554 47.3425 26.8022 47.3238C26.8502 47.3051 26.9345 47.3308 27.0551 47.3986L27.3349 47.5588V48.2334Z",
    fill: "#471D1D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2432 46.496L25.8358 46.2656L25.474 46.911L25.1111 45.8541L24.706 45.6238L25.2855 47.3377V48.2392L25.659 48.4531V47.5505L26.2432 46.496Z",
    fill: "#471D1D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4366 45.429L30.3946 35.5755L31.7234 34.8342L48.7654 44.6866V47.641L47.4097 48.4466L47.4366 45.429Z",
    fill: "#F2E5DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.6273ec7816b214281debc2f60a01b48d.svg";
export { ForwardRef as ReactComponent };